<section class="login-page">
  <div class="login-card">
    <h1>{{ productName }}</h1>
    <p>Please sign in with your Keycloak account to continue.</p>
    <button type="button" class="sign-in" (click)="signIn()" data-test="sign-in">Sign in</button>
  </div>
</section>
